/**
 * REACT_APP_BACKEND_URL viene iniettato in fase di build (CRA).
 * Normalizza slash finali e un eventuale suffisso .../api (evita .../api/api/leads).
 */
const DEFAULT_BACKEND_URL = "https://leadlegale-app.onrender.com";

function assertProductionHttpsBrowser() {
  if (typeof window === "undefined") return;
  if (process.env.NODE_ENV !== "production") return;
  if (!window.location.href.startsWith("https://")) {
    throw new Error("HTTPS richiesto");
  }
}

export function getApiBase() {
  assertProductionHttpsBrowser();
  const raw = process.env.REACT_APP_BACKEND_URL;
  // Prefer configured env var; fallback to browser origin for dynamic runtime contexts.
  const dynamicOrigin = typeof window !== "undefined" && window.location?.origin
    ? window.location.origin
    : DEFAULT_BACKEND_URL;
  const source = raw == null || String(raw).trim() === "" ? dynamicOrigin : raw;
  if (source == null || String(source).trim() === "") return "";
  let u = String(source).trim().replace(/\/+$/, "");
  if (/\/api$/i.test(u)) {
    u = u.replace(/\/api$/i, "");
    u = u.replace(/\/+$/, "");
  }
  return u;
}

export function apiUrl(path) {
  const base = getApiBase();
  const p = path.startsWith("/") ? path : `/${path}`;
  return base ? `${base}${p}` : p;
}

/** Estrae gli item da GET /api/leads (v2.1 paginato o legacy array). */
export function leadsFromApiPayload(data) {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.items)) return data.items;
  return [];
}

export const LEADS_PAGE_SIZE = 200;

/** Timeout richieste auth / wake-up (ms). */
export const AUTH_REQUEST_TIMEOUT_MS = 12000;

export function isTransientApiError(err) {
  if (!err) return false;
  const status = err?.response?.status;
  if ([502, 503, 504, 408, 429].includes(status)) return true;
  if (!err.response) {
    const code = String(err?.code || '').toUpperCase();
    const message = String(err?.message || '').toLowerCase();
    if (
      code === 'ECONNABORTED' ||
      code === 'ERR_NETWORK' ||
      code === 'ETIMEDOUT' ||
      message.includes('network error') ||
      message.includes('timeout')
    ) {
      return true;
    }
  }
  return false;
}

export function isAuthSessionError(err) {
  const status = err?.response?.status;
  if (status === 401) return true;
  const detail = String(err?.response?.data?.detail || '').toLowerCase();
  return (
    detail.includes('token') ||
    detail.includes('non valido') ||
    detail.includes('scaduto') ||
    detail.includes('non autenticato') ||
    detail.includes('tipo token')
  );
}

export function readCachedUser() {
  try {
    const raw = localStorage.getItem('leadlegale_user');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
